export default __webpack_public_path__ + "static/media/2-3.f529f53b.webp";